import { VendorListPage } from '@/features/vendor/pages/VendorListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorListPage,
})
